export const formatDayLabel = (translate, day) => {
    const label = translate(`labels.days.${day}`);
    if (typeof label !== "string" || label.length === 0) {
        return day;
    }

    return label.charAt(0).toUpperCase() + label.slice(1);
};

export const normalizeDays = (rawDays, englishDays) => {
    if (Array.isArray(rawDays)) {
        return rawDays;
    }

    if (typeof rawDays === "string") {
        try {
            const parsed = JSON.parse(rawDays);
            if (Array.isArray(parsed)) {
                return parsed;
            }
            if (parsed && typeof parsed === "object") {
                return englishDays.filter((englishDay) => parsed[englishDay]);
            }
        } catch (error) {
            return [];
        }
    }

    return [];
};

export const mapSlotsFromApi = (slots = []) =>
    slots.reduce((result, slot) => {
        result[slot.hour_start] = {
            hour_start: slot.hour_start,
            is_max_pax_enabled: slot.is_max_pax_enabled,
            max_pax: slot.max_pax,
            is_max_reservations_enabled: slot.is_max_reservations_enabled,
            max_reservations: slot.max_reservations,
        };

        return result;
    }, {});

export const mapMenusFromApi = (menus = []) =>
    menus.reduce((result, menu) => {
        result[menu.id] = {
            id: menu.id,
            enable_nb_min_pers: menu.pivot.enable_nb_min_pers,
            nb_min_pers: menu.pivot.nb_min_pers,
            enable_nb_max_pers: menu.pivot.enable_nb_max_pers,
            nb_max_pers: menu.pivot.nb_max_pers,
        };

        return result;
    }, {});

export const mapRestaurantsProposals = (restaurants = [], restaurantsToSuggest = []) => {
    const allowed = new Set(restaurantsToSuggest.map((restaurant) => restaurant.id));

    return restaurants.filter((restaurant) => allowed.has(restaurant.id)).map((restaurant) => restaurant.id);
};

const buildDefaultDuration = () => ({
    HH: "01",
    mm: "00",
});

export const buildPaxesDurations = (paxDurations = [], maxPax = 0, getDefaultDuration = buildDefaultDuration) => {
    const limit = maxPax > 10 ? maxPax : 10;
    const result = [];

    for (let pax = 1; pax <= limit; pax += 1) {
        const paxFound = paxDurations.find((value) => value.pax === pax);
        if (!paxFound) {
            result.push({
                pax,
                duration: getDefaultDuration(),
            });
            continue;
        }

        const [hours = "00", minutes = "00"] = `${paxFound.duration || "00:00"}`.split(":");
        result.push({
            pax: paxFound.pax,
            duration: {
                HH: hours,
                mm: minutes,
            },
        });
    }

    return result;
};
